import { parseTags } from 'service/campaigns'

export const UseParseTag = (tags, isAnActiveCampaign) => {
  const parseTagsHook = [...new Set(parseTags(tags, isAnActiveCampaign))]

  return parseTagsHook
}
